<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-monitor"></i> 职工管理</span>
      </div>

      <!-- 搜索区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="demo-form-inline"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 分类 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="姓名">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入姓名"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" icon="el-icon-plus" @click="openAddDialog">
            新增
          </el-button>
          <el-button type="success" @click="downloadTemplate">
            下载模板
          </el-button>
          <el-button type="warning" @click="openImportDialog">
            批量导入
          </el-button>
        </div>
      </el-form>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column label="性别">
          <template slot-scope="scope">
            {{ scope.row.sex === 1 ? "男" : scope.row.sex === 2 ? "女" : "" }}
          </template>
        </el-table-column>
        <!-- <el-table-column prop="adminRoleType" label="角色">
          <template slot-scope="scope">
            {{ getAdminRoleTypeName(scope.row.adminRoleType) }}
          </template>
        </el-table-column> -->
        <el-table-column prop="roleName" label="职务"></el-table-column>
        <el-table-column prop="mobile" label="手机号码"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)" type="primary"
              >编辑</el-button
            >
            <el-button
              size="mini"
              @click="changePassword(scope.row)"
              type="warning"
              >重置密码</el-button
            >
            <el-button size="mini" @click="deleteItem(scope.row)" type="danger"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- admin重置密码的弹窗 -->
      <el-dialog
        title="重置密码"
        :visible.sync="passwordDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form
          :model="passwordForm"
          :rules="passwordFormRules"
          ref="passwordFormRef"
        >
          <el-form-item label="新密码" prop="defaultPassword">
            <el-input
              v-model="passwordForm.defaultPassword"
              placeholder="请输入新密码"
              style="width: 380px"
              show-password
            />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="passwordDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="resetPassword">确定重置</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="isEdit ? '编辑' : '新增'"
        :visible.sync="dialogVisible"
        width="500px"
        @close="resetForm"
        class="dialog-container"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="form" :rules="rules" ref="formRef" label-width="100px">
          <el-form-item label="姓名" prop="name">
            <el-input
              v-model="form.name"
              placeholder="请输入姓名"
              style="width: 350px"
            />
          </el-form-item>

          <!-- <el-form-item label="行政角色" prop="adminRoleType">
            <el-select
              v-model="form.adminRoleType"
              placeholder="请选择行政角色"
              style="width: 350px"
            >
              <el-option label="行政" :value="1" />
              <el-option label="教师" :value="2" />
            </el-select>
          </el-form-item> -->

          <el-form-item label="职务" prop="roleId">
            <el-select
              v-model="form.roleId"
              placeholder="请选择职务"
              style="width: 350px"
            >
              <el-option
                v-for="role in roleOptions"
                :key="role.id"
                :label="role.name"
                :value="role.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="联系电话" prop="mobile">
            <el-input
              v-model="form.mobile"
              placeholder="请输入联系电话"
              style="width: 350px"
            />
          </el-form-item>

          <!-- 添加密码输入框，仅在新增时显示 -->
          <el-form-item label="默认密码" prop="password" v-if="!isEdit">
            <el-input
              v-model="form.password"
              placeholder="请输入默认密码"
              style="width: 350px"
              show-password
            />
          </el-form-item>

          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="form.sex">
              <el-radio :label="1">男</el-radio>
              <el-radio :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" class="cancel-button"
            >取消</el-button
          >
          <el-button type="primary" @click="saveItem" class="save-button"
            >保存</el-button
          >
        </div>
      </el-dialog>

      <!-- 批量导入弹窗 -->
      <el-dialog
        title="批量导入"
        :visible.sync="importDialogVisible"
        width="500px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form :model="importForm" ref="importFormRef" label-width="80px">
          <el-form-item label="选择文件">
            <el-upload
              :headers="uploadHeaders"
              :action="UPLOAD_URL"
              :auto-upload="false"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              :http-request="customUpload"
              :file-list="fileList"
              accept=".xlsx, .xls"
            >
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <div slot="tip" class="el-upload__tip">
                只能上传xlsx/xls文件，且不超过10MB
              </div>
            </el-upload>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="importData">导入</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import {
  teacherPage,
  teacherDownloadTemplate,
  teacherAddOrEdit,
  userImport,
  userDelete,
  adminChangePassWord,
} from "@/api/material";
import { rolePage } from "@/api/staff.js";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile } from "@/utils/util";
import { UPLOAD_URL } from "@/utils/const";
import { getToken } from "@/utils/auth";

export default {
  name: "MaterialManagement",
  components: { PaginationBar },
  data() {
    return {
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      UPLOAD_URL,
      passwordDialogVisible: false,
      passwordForm: {
        id: "",
        defaultPassword: "123456", // 默认密码
      },
      passwordFormRules: {
        defaultPassword: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { min: 6, message: "密码长度不能少于6位", trigger: "blur" },
        ],
      },
      importDialogVisible: false,
      importForm: {},
      fileList: [],
      importFile: null,
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      queryParams: {
        name: "",
      },
      tableData: [],
      roleOptions:[],//
      dialogVisible: false,
      form: {
        name: "",
        // adminRoleType: "",
        roleId: "", // 添加职务字段
        mobile: "",
        sex: "", // 性别：1-男，2-女
        password: "123456", //新创建的时候，要设置默认密码
      },
      isEdit: false,
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        // adminRoleType: [
        //   { required: true, message: "请选择行政角色", trigger: "change" },
        // ],
        roleId: [
          { required: true, message: "请选择职务", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        sex: [{ required: false, message: "请选择性别", trigger: "change" }],
        password: [
          { required: true, message: "请输入默认密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 请求所有的职务的类型
    getAllRoleType() {
      // 请求所有的职务的类型
      rolePage({
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        this.roleOptions = res.records || []
      });
    },
    // 获取行政角色名称
    getAdminRoleTypeName(roleType) {
      const roleMap = {
        1: "行政",
        2: "教师",
      };
      return roleMap[roleType] || "";
    },
    // 重置密码相关方法
    changePassword(row) {
      this.passwordDialogVisible = true;
      this.$nextTick(() => {
        this.passwordForm.id = row.id;
        // 重置密码输入框
        this.passwordForm.defaultPassword = "";
        // 重置表单验证状态
        if (this.$refs.passwordFormRef) {
          this.$refs.passwordFormRef.resetFields();
        }
      });
    },
    resetPassword() {
      // 验证表单
      this.$refs.passwordFormRef.validate((valid) => {
        if (!valid) {
          return false;
        }

        // 调用重置密码接口
        adminChangePassWord({
          userId: this.passwordForm.id,
          password: this.passwordForm.defaultPassword,
        })
          .then(() => {
            this.$message.success("密码重置成功");
            this.passwordDialogVisible = false;
            this.handleQuery(this.currentPage);
          })
          .catch((error) => {
            this.$message.error(
              "密码重置失败: " + (error.message || "未知错误")
            );
          });
      });
    },
    // 导入数据
    importData() {
      if (!this.importFile) {
        this.$message.warning("请选择要导入的文件");
        return;
      }

      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: "正在导入数据...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 创建 FormData 对象
      const formData = new FormData();
      formData.append("file", this.importFile);

      // 调用导入API
      userImport(formData)
        .then(() => {
          loading.close();
          this.$message.success("导入成功");
          this.importDialogVisible = false;
          this.handleQuery(this.currentPage);
        })
        .catch((error) => {
          loading.close();
          this.$message.error("导入失败: " + (error.message || "未知错误"));
        });
    },

    // 打开导入弹窗
    openImportDialog() {
      this.importDialogVisible = true;
      this.fileList = [];
      this.importFile = null;
    },
    // 上传前验证
    beforeUpload(file) {
      // 获取文件扩展名
      const fileName = file.name;
      const fileExtension = fileName
        .substring(fileName.lastIndexOf("."))
        .toLowerCase();

      // 验证文件类型
      const validExtensions = [".xlsx", ".xls"];

      if (!validExtensions.includes(fileExtension)) {
        this.$message.error("只能上传Excel格式的文件（.xlsx 或 .xls）");
        return false;
      }

      // 验证文件大小（10MB限制）
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$message.error("文件大小不能超过10MB");
        return false;
      }

      return true;
    },
    // 自定义上传方法（不实际上传）
    customUpload() {
      // 空实现，因为我们不希望自动上传
      return false;
    },
    handleFileChange(file, fileList) {
      // 验证文件类型
      const isValid = this.beforeUpload(file);
      if (!isValid) {
        // 如果验证不通过，清除文件列表
        this.$refs.upload.clearFiles();
        return false;
      }

      this.importFile = file.raw;
      this.fileList = fileList;
    },
    // 下载模板
    downloadTemplate() {
      teacherDownloadTemplate().then((res) => {
        downloadFile(res.data, "职工导入模板.xlsx");
      });
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      teacherPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams.name = "";
      this.currentPage = 1;
      this.handleQuery();
    },
    openAddDialog() {
      this.dialogVisible = true;
      this.false = true;
    },
    handleEdit(row) {
      this.isEdit = true;
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.form = {
          name: row.name,
          // adminRoleType: row.adminRoleType,
          mobile: row.mobile,
          roleId: row.roleId, // 添加职务字段
          sex: row.sex,
          id: row.id,
        };
      });
    },

    saveItem() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return;

        teacherAddOrEdit(this.form).then(() => {
          this.dialogVisible = false;
          this.handleQuery(this.currentPage);
          this.$message.success("操作成功");
        });
      });
    },
    resetForm() {
      this.$refs.formRef && this.$refs.formRef.resetFields();
      this.isEdit = false;
      this.form = {
        name: "",
        // adminRoleType: "",
        mobile: "",
        sex: "",
        password: "123456", // 重置为默认密码
      };
    },
    deleteItem(row) {
      this.$confirm("确定删除当前教师？", "提示", { type: "warning" })
        .then(() => {
          // 删除逻辑
          userDelete({ userId: row.id }).then(() => {
            this.$message.success("删除成功！");
            this.handleQuery(this.currentPage);
          });
        })
        .catch(() => {});
    },
  },
  created() {
    this.handleQuery();
    this.getAllRoleType();
  },
};
</script>

<style scoped>
.app-container {
}
.dialog-container {
  /* 调整 dialog 的样式 */
  border-radius: 8px;
}
.form-input {
  width: 100%;
  margin-top: 10px;
}

.el-form-item {
  margin-bottom: 20px; /* 调整每个表单项的间距 */
}

.dialog-footer {
  /* 底部按钮区间距和对齐 */
  text-align: center;
}

.cancel-button,
.save-button {
  margin-left: 10px; /* 按钮间隔 */
}

.save-button {
  background-color: #409eff;
  border-color: #409eff;
}

.cancel-button {
  background-color: #f5f5f5;
  border-color: #dcdfe6;
}
</style>
